<div class="notification d-flex align-items-start gap-3">
    <svg-icon src="assets/icons/calendar.svg" class="notification-icon d-flex align-items-center justify-content-center"/>
    <div class="flex-grow-1 d-flex flex-column gap-2 justify-content-between">
        <h3 class="nunito-bold">
            @if (notification().type === notificationType.NEW_APPOINTMENT)
            {
                {{'NOTIFICATIONS.NEW_APPOINTMENT' | translate}}
            }
            @else
            {
                {{'NOTIFICATIONS.CANCELLED_APPOINTMENT' | translate}}
            }
        </h3>
        @if (notification().patient)
        {
            <div class="d-flex align-items-center gap-8">
                <svg-icon src="assets/icons/profile.svg" class="person-icon d-flex align-items-center justify-content-center"/>
                <p class="nunito-regular person-name">{{notification().patient}}</p>
            </div>
        }
        <div class="d-flex align-items-center gap-8">
            <p class="nunito-semibold date">{{notification().date | date: 'dd MMM, yyyy'}}</p>
            <div class="circle"></div>
            <p class="nunito-semibold date">{{notification().date | date: 'HH:mm'}}</p>
        </div>
        @if (notification().clinician)
        {
            <div class="d-flex align-items-center gap-8">
                <svg-icon src="assets/icons/clinic.svg" class="person-icon d-flex align-items-center justify-content-center"/>
                <p class="nunito-regular person-name">{{notification().clinician}}</p>
            </div>
        }
        <p class="nunito-regular clinic">{{notification().clinic}}</p>
    </div>
    <app-button icon="close" type="transparent" theme="secondary" [fullWidth]="false" class="close-button" (pressed)="pressed.emit()"/>
</div>
